import type { SpecialPageCtas } from '../../fetchSurvey/types';

/**
 * Strip email-capture CTAs from end/terminal pages. API may map sendEmailResponse
 * on end pages; agents must filter before rendering SpecialPageCtaSection.
 */
export function endPageCtas(ctas?: SpecialPageCtas): SpecialPageCtas | undefined {
  if (!ctas) return undefined;
  const { sendEmailResponse: _sendEmailResponse, resumptionNotification: _resumptionNotification, reopenNotification: _reopenNotification, ...rest } = ctas;
  return Object.keys(rest).length > 0 ? rest : undefined;
}
